import { render } from "./Select2.vue?vue&type=template&id=42bc7b92&scoped=true"
import script from "./Select2.vue?vue&type=script&lang=js"
export * from "./Select2.vue?vue&type=script&lang=js"

import "./Select2.vue?vue&type=style&index=0&id=42bc7b92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42bc7b92"]])

export default __exports__